import React from 'react';
import { DonutChart, BarChart } from '@mantine/charts';
import { Card, Text, Title, Group, Stack, Grid, Box } from '@mantine/core';

export const DashboardCharts = ({ data }) => {
  const { itemsPostpago, itemsPrepago, totalPostpago, totalPrepago } = data;

  const customerDistribution = [
    { name: 'Postpago', value: itemsPostpago || 0, color: 'yellow.6' },
    { name: 'Prepago', value: itemsPrepago || 0, color: 'gray.6' },
  ];

  const revenueData = [
    {
      category: 'Ingresos por Modalidad',
      Postpago: totalPostpago || 0,
      Prepago: totalPrepago || 0,
    },
  ];

  return (
    <Grid gutter="xl">
      <Grid.Col span={{ base: 12, md: 6 }}>
        <Card withBorder radius="lg" p="xl" shadow="sm" h="100%">
          <Stack align="center" gap="md">
            <Box style={{ textAlign: 'center' }}>
              <Title order={4} tt="uppercase" className="tracking-widest" c="dark.4">Distribución de Clientes</Title>
              <Text size="xs" c="dimmed">Proporción por tipo de contrato</Text>
            </Box>
            
            <DonutChart 
              data={customerDistribution} 
              withLabelsLine 
              labelsType="percent" 
              withLabels 
              size={180} 
              thickness={25}
              tooltipDataSource="segment"
              mx="auto"
              mt="md"
            />

            <Group gap="xl" mt="md" justify="center">
              {customerDistribution.map((item) => (
                <Group key={item.name} gap={6}>
                  <Box w={10} h={10} style={{ borderRadius: '50%', backgroundColor: `var(--mantine-color-${item.color.replace('.', '-')})` }} />
                  <Text size="xs" fw={700} c="dark.3">{item.name}: {item.value}</Text>
                </Group>
              ))}
            </Group>
          </Stack>
        </Card>
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 6 }}>
        <Card withBorder radius="lg" p="xl" shadow="sm" h="100%">
          <Stack gap="md" h="100%">
            <Box>
              <Title order={4} tt="uppercase" className="tracking-widest" c="dark.4">Rendimiento Mensual</Title>
              <Text size="xs" c="dimmed">Comparativa de ingresos brutos (MXN)</Text>
            </Box>

            <Box style={{ flex: 1, display: 'flex', alignItems: 'center', minHeight: 200 }}>
              <BarChart
                h={200}
                data={revenueData}
                dataKey="category"
                series={[
                  { name: 'Postpago', color: 'yellow.6' },
                  { name: 'Prepago', color: 'gray.6' },
                ]}
                tickLine="y"
                gridAxis="xy"
                unit=" MXN"
                withLegend
                valueFormatter={(value) => new Intl.NumberFormat('es-MX').format(value)}
              />
            </Box>
          </Stack>
        </Card>
      </Grid.Col>
    </Grid>
  );
};
